import React from "react";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { icon, label } from "../../../../config";
import { email_icon, email_label } from "./TaskEmailConstant";

/**
 * EmailHeader component for the email section
 * @param {Object} props - Component props
 * @param {Function} props.handleRefresh - Function to handle refresh action
 * @param {Function} props.handleSearch - Function to handle search action
 * @author Sejal
 */
const EmailHeader = ({ handleRefresh, handleSearch }) => {
  return (
    <Tooltip anchorElement='target' parentTitle={true} position='bottom'>
      <div className='email-header-actions'>
        <div>
          <button className='compose-btn ' title={label.COMING_SOON}>
            {email_label.COMPOSE}
          </button>
        </div>
        <div className='d-flex'>
          <button className='refresh-btn border-none' title={label.REFRESH} onClick={handleRefresh}>
            {icon.REFRESH_APP}
          </button>
          <div className='search-group position-relative'>
            <input
              title={label.OVERALL_SEARCH_INPUT_TITLE}
              type='text'
              className='form-control'
              placeholder='Find'
              autoComplete='off'
              onChange={(e) => handleSearch(e.target.value)}
            />
            <span className='search-icon position-absolute'>{icon.SEARCH}</span>
          </div>
        </div>
      </div>
    </Tooltip>
  );
};

export default EmailHeader;
